import useFeatureFlags from "@/hooks/useFeatureFlags";

interface UseShouldShowOnboarding {
  shouldShowOnboarding: boolean;
}

const useShouldShowOnboarding = (): UseShouldShowOnboarding => {
  const { isOnboardingV2Enabled } = useFeatureFlags();

  return {
    shouldShowOnboarding: isOnboardingV2Enabled,
  };
};

export default useShouldShowOnboarding;
